import { ButtonMainWithListLogic as ButtonMainWithList } from './ButtonMainWithList.logic'

export default ButtonMainWithList
